import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MerchantOverviewStockPage } from './merchant-overview-stock';

@NgModule({
  declarations: [
    MerchantOverviewStockPage,
  ],
  imports: [
    IonicPageModule.forChild(MerchantOverviewStockPage),
    TranslateModule.forChild()
  ],
})
export class MerchantOverviewStockPageModule {}



// WEBPACK FOOTER //
// ./src/pages/merchant-overview-stock/merchant-overview-stock.module.ts